
	export default {
		data(){
			return {
				darkMode: false
			}
		},
	}
